import { animate, query, style, transition, trigger } from '@angular/animations';

export const routeTransition = trigger('routeTransition', [
  transition('* <=> *', [
    query(':enter, :leave', [
      style({
        position: 'absolute',
        flexDirection: 'column',
        alignItems: 'center',
        display: 'flex',
        top: 0,
        left: 0,
        width: '100%',
      })
    ], { optional: true }),
    query(':enter', [
      style({ opacity: 0 }),
    ], { optional: true }),
    query(':leave', [
      animate('0.2s ease-out', style({ opacity: 0 })),
    ], { optional: true }),
    query(':enter', [
      animate('0.2s ease-in', style({ opacity: 1 })),
    ], { optional: true }),
  ])
]);
